import { useEffect } from "react";
import PropTypes from "prop-types";
import { Flex, Image } from "rebass";

import { InputLabel, ErrorLabel } from "./index";

const SelectedOverlay = () => (
	<Flex
		width="100%"
		justifyContent="center"
		alignItems="center"
		css={`
			position: absolute;
			height: 100%;
			z-index: 1;
			background-color: rgba(51, 51, 51, 0.6);
		`}
	>
		<Image
			src="/static/icons/misc/checkmark.svg"
			width="15%"
			alt="e-card image selected"
			css={`
				opacity: 1;
			`}
		/>
	</Flex>
);

const CardImageList = ({
	name,
	images = [],
	label = "",
	values,
	error,
	setFieldValue,
}) => {
	useEffect(() => {
		const selectedImage =
			values[name].length &&
			images.find((image) => image.id === values[name]);
		if (!values[name].length && images.length) {
			// Set default
			setFieldValue(name, images[0].id);
		} else if (values[name].length && !selectedImage) {
			// clear fieldValue if image list changes
			setFieldValue(name, "");
		}
	}, [images]);

	return (
		<Flex
			as="fieldset"
			flexDirection="column"
			width="100%"
			css={`
				border: none;
				padding: 0;
			`}
		>
			<InputLabel as="label">{label}</InputLabel>
			<Flex
				name={name}
				width="100%"
				flexWrap="wrap"
				mb={error ? 0 : 6}
				data-testid="selectedECardImage"
			>
				{images.map((image) => (
					<Flex
						key={image.id}
						width={[1 / 2, 1 / 2, 1 / 2, 1 / 3]}
						onClick={() => setFieldValue(name, image.id)}
						css={`
							position: relative;
							border: 2px solid white;
							cursor: pointer;
						`}
						tabIndex={0}
					>
						{image.id === values[name] && <SelectedOverlay />}
						{/* Card images should be 1280x853 for best results */}
						<Image src={image.url} />
					</Flex>
				))}
			</Flex>
			{error && (
				<ErrorLabel data-testid="error-label">{error}</ErrorLabel>
			)}
		</Flex>
	);
};

CardImageList.propTypes = {
	name: PropTypes.string.isRequired,
	images: PropTypes.arrayOf(
		PropTypes.shape({
			url: PropTypes.string,
			id: PropTypes.number,
			type: PropTypes.oneOf(["honour", "memorial"]),
		}),
	),
	label: PropTypes.string.isRequired,
	values: PropTypes.shape({
		typeOfTribute: PropTypes.oneOf(["honour", "memorial"]),
	}),
	error: PropTypes.string,
	setFieldValue: PropTypes.func,
};

export default CardImageList;
